import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const loading = {
  namespaced: true,
  state: {
    isLoading: false,
    lastCallElementToOnBlur: null
  },
  getters,
  mutations,
  actions
};
